import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const questions = [['How do I receive the system after purchasing?', 'You receive instant digital access to all materials so you can choose and use lessons immediately.'], ['What level of ESL teacher is this for?', 'ESL Teacher Ready works for new and experienced teachers working with A1, A2, and B1 learners.'], ['Does this work for ESL teachers in any country?', 'Yes. The system is designed for ESL and EFL teachers in schools, institutes, online classrooms, and freelance settings worldwide.'], ['Can I adapt the material?', 'Yes. Each lesson is ready to teach as it is, and you can adapt individual elements for your classroom context.'], ['What if I do not find it useful?', 'You are protected by a 7-day money-back guarantee. If it does not deliver what we promise, contact us for a full refund.']];
export function FAQ() {
  const [active, setActive] = useState<number | null>(0);
  return <section className="bg-cream px-4 py-20 sm:py-28" data-id="element-32">
      <div className="mx-auto max-w-3xl" data-id="element-33">
        <div className="text-center" data-id="element-34">
          <div className="section-rule mx-auto" data-id="element-35" />
          <p className="mt-5 text-xs font-extrabold tracking-[.16em] text-gold-500" data-id="element-36">
            NEED TO KNOW
          </p>
          <h2 className="mt-4 font-display text-3xl uppercase text-navy-950 sm:text-5xl" data-id="element-37">
            Frequently asked questions
          </h2>
        </div>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#e6d9b7] bg-white shadow-card" data-id="element-38">
          {questions.map(([question, answer], index) => {
          const isOpen = active === index;
          return <div key={question} className="border-b border-[#eee4cb] last:border-0" data-id="element-39">
                <button type="button" onClick={() => setActive(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left text-sm font-extrabold text-navy-950 focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-300/40 sm:text-base" data-id="element-40">
                  {question}
                  <ChevronDownIcon className={`shrink-0 text-gold-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-41" />
                </button>
                {isOpen && <p className="px-6 pb-6 text-sm leading-6 text-slate-600" data-id="element-42">
                    {answer}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}